import { render } from "./ModalContenedorComponent.vue?vue&type=template&id=3f64f310&scoped=true"
import script from "./ModalContenedorComponent.vue?vue&type=script&lang=js"
export * from "./ModalContenedorComponent.vue?vue&type=script&lang=js"

import "./ModalContenedorComponent.vue?vue&type=style&index=0&id=3f64f310&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f64f310"]])

export default __exports__